import { taggedTemplateLiteralLoose as _taggedTemplateLiteralLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { spaceMixin, mediaMixin } from '@zillow/constellation';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import CalculatorForm from '../CalculatorForm/CalculatorForm.js';
import { omitUndefined } from '../../utils/lodash.js';
import { FieldConfig, DEFAULT_VALUES_SHAPE } from './MortgageCalculator.utils.js';
export { DEFAULT_VALUES_SHAPE } from './MortgageCalculator.utils.js';
import MortgageFields from './MortgageFields.js';
import MortgageDonutChart from './MortgageDonutChart.js';
import { LOAN_PROGRAMS, amountAsNumber } from '../../utils/zhl-calculator.js';

var _templateObject;
var StyledCalculatorForm = /*#__PURE__*/styled(CalculatorForm).withConfig({
  componentId: "sc-nk0gdv-0"
})(["padding-bottom:", ";display:flex;flex-direction:column-reverse;", ";"], spaceMixin('md'), mediaMixin('md', css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n            flex-direction: row;\n            &:first-child,\n            &:last-child {\n                flex-grow: 1;\n            }\n            align-items: center;\n        "])))));
var MortgageCalculator = function MortgageCalculator(_ref) {
  var _Object$assign;
  var defaultValues = _ref.defaultValues,
    editorMode = _ref.editorMode;
  var finalDefaultValues = Object.assign((_Object$assign = {}, _Object$assign[FieldConfig.homePrice.name] = 225000, _Object$assign[FieldConfig.loanProgram.name] = LOAN_PROGRAMS.fixed30Year, _Object$assign[FieldConfig.interestRate.name] = 5, _Object$assign[FieldConfig.downPayment.name] = 45000, _Object$assign[FieldConfig.homeInsurance.name] = 945, _Object$assign[FieldConfig.hoa.name] = 0, _Object$assign[FieldConfig.taxRate.name] = 1.2, _Object$assign[FieldConfig.includeTaxesInsurance.name] = true, _Object$assign[FieldConfig.includePMI.name] = true, _Object$assign), omitUndefined(defaultValues));
  finalDefaultValues[FieldConfig.downPaymentPercent.name] = amountAsNumber(finalDefaultValues[FieldConfig.downPayment.name]) / amountAsNumber(finalDefaultValues[FieldConfig.homePrice.name]) * 100;
  return /*#__PURE__*/React.createElement(StyledCalculatorForm, {
    fieldStorageKey: "mortgageFields",
    defaultValues: finalDefaultValues,
    editorMode: editorMode
  }, /*#__PURE__*/React.createElement(MortgageFields, null), /*#__PURE__*/React.createElement(MortgageDonutChart, null));
};
MortgageCalculator.defaultProps = {
  defaultValues: undefined,
  editorMode: undefined
};
MortgageCalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  defaultValues: PropTypes.shape(DEFAULT_VALUES_SHAPE),
  editorMode: PropTypes.bool
} : {};
var MortgageCalculator$1 = MortgageCalculator;

export { MortgageCalculator$1 as default };
